// Applies to the longer side, so portrait plans stay as small in the replay payload as landscape ones
export const REPLAY_PLAN_COPY_LONGEST_SIDE_PX = 1000;

export const REPLAY_PLAN_COPY_JPEG_QUALITY = 0.6;
